import React from 'react';
import classNames from 'classnames';
import { Fade } from 'react-awesome-reveal';
import { Block, Paragraph } from '@uncinc/react-drupal-core';
import { useSelector } from 'react-redux';
import config from 'react-global-configuration';

import usePhaseState from '../../../../helpers/usePhaseState';
import { useAspectRatio } from '../../../../helpers/useAspectRatio';

import {
  Container,
  WysiwygField,
  PatternBlock,
  Button,
  Breadcrumbs,
  DynamicMediaItem,
} from '../../../../components';
import { APP_OPTIONS, AVO_PHASE_DURING, APPELTJES_DOMAIN } from '../../../../config/constants';

import './style.scss';

const NodeLandingPageFull = ({ entity, className }) => {
  const domain = config.get('CURRENT_DOMAIN');
  let hero = false;
  let videoHeader = false;
  let filteredElements = entity.getIn(['field_paragraphs']);
  const path = useSelector((state) => state.getIn(['router', 'location', 'pathname']));
  const isAvoRoute = domain === APPELTJES_DOMAIN && path === '/projecten';
  const phase = usePhaseState();
  const avoBlockClass = classNames({
    'hide-primary-button': phase === AVO_PHASE_DURING && path === APP_OPTIONS.parameters.avoProjectOverviewUri,
  });


  entity.get('field_paragraphs').forEach((element, i) => {
    if (element.getIn(['entity', 'type', 0, 'target_id']) === 'hero') {
      hero = element;
      filteredElements = entity.getIn(['field_paragraphs']).delete(i);
    }
    if (element.getIn(['entity', 'type', 0, 'target_id']) === 'video_header') {
      videoHeader = element;
      filteredElements = entity.getIn(['field_paragraphs']).delete(i);
    }
  });

  const heroLink = entity.getIn(['field_link', 0, 'uri']);
  const heroLinkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkRel = entity.getIn(['field_link', 0, 'options', 'attributes', 'rel']);
  const backgroundImage = entity.getIn(['field_image', 0], null);

  let button;
  if (heroLink && heroLinkTitle) {
    button = <Button secondary withIcon buttonIcon href={heroLink}>{heroLinkTitle}</Button>;
  }

  const classes = classNames(className, 'LandingPage', {
    'extra-padding': (linkRel && linkRel === 'doe-je-mee'),
  });

  const blockColClasses = classNames('col-12 col-lg-8 offset-lg-2', {
    'col-md-8 offset-md-2': isAvoRoute,
    'hide-active-primary-btn': isAvoRoute && phase === AVO_PHASE_DURING,
  });

  const aspectRatio = useAspectRatio({
    small: '4_3',
    medium: '2_1',
    large: '7_3',
    xlarge: '8_3',
  });

  return (
    // eslint-disable-next-line react/no-unknown-property
    <article typeof="schema:WebPage" className={classes}>
      <Container>
        {backgroundImage &&
          <div className="LandingPage__hero">
            <DynamicMediaItem
              className="LandingPage__hero__image"
              media={backgroundImage.toJS()}
              imageAspectRatio={aspectRatio}
              alt={backgroundImage.toJS().alt}
            />
          </div>}
        {hero && !backgroundImage && (
          <Paragraph id={hero.get('target_id')} />
        )}
        {!hero && videoHeader && !backgroundImage && (
          <Paragraph id={videoHeader.get('target_id')} />
        )}
      </Container>

      {(!entity.get('is_front', false) || entity.getIn(['body', 0, 'processed'])) && !videoHeader && (
        (backgroundImage || hero) ? (
          <Container>
            <div className="row">
              <div className={blockColClasses}>
                {
                  isAvoRoute ? (
                    <div className={avoBlockClass}>
                      <Block id={APP_OPTIONS.parameters.avoBlockIds[phase]} />
                    </div>
                  ) : (
                    <PatternBlock className="LandingPage LandingPage__intro">
                      {!entity.get('is_front', false) ? (
                        <Fade triggerOnce bottom distance="50px" duration={500}>
                          <h1 className="LandingPage__title page-header">{entity.getIn(['title', 0, 'value'])}</h1>
                        </Fade>
                      ) : null}
                      {entity.getIn(['body', 0, 'processed']) ? (
                        <WysiwygField
                          property="schema:text"
                          className="LandingPage__body"
                          html={entity.getIn(['body', 0, 'processed'], '')}
                        />
                      ) : null}
                      {button}
                    </PatternBlock>
                  )
                }
              </div>
            </div>
          </Container>
        ) : (
          <>
            <Container>
              <Breadcrumbs includeCurrent />
            </Container>
            <Container>
              <div className="row">
                <div className="col-12 col-lg-8 offset-lg-2">
                  <div className="LandingPage">
                    {!entity.get('is_front', false) ? (
                      <Fade triggerOnce bottom distance="50px" duration={500}>
                        <h1 className="LandingPage__title page-header">{entity.getIn(['title', 0, 'value'])}</h1>
                      </Fade>
                    ) : null}
                    {entity.getIn(['body', 0, 'processed']) ? (
                      <WysiwygField
                        property="schema:text"
                        className="LandingPage__body"
                        html={entity.getIn(['body', 0, 'processed'], '')}
                      />
                    ) : null}
                    {button}
                  </div>
                </div>
              </div>
            </Container>
          </>
        )
      )}

      <div className="Paragraphs">
        {
          filteredElements.map((item, index) => {
            const paragraphId = item.get('target_id');
            const paragraph = item.getIn(['entity']);
            return (
              <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} />
            );
          })
        }
      </div>
    </article>
  );
};

export default NodeLandingPageFull;

